import { render } from "./RedirectViewAir.vue?vue&type=template&id=68845cd4"
import script from "./RedirectViewAir.vue?vue&type=script&lang=js"
export * from "./RedirectViewAir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__